/**
 * Animate on Scroll JS
 * Using IntersectionObserver for performance
 */

(function animateOnScroll() {
  const animations = document.querySelectorAll('[data-animate]');
  if (animations.length === 0) return;

  const observers = new Map();

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  function onAnimate(entries) {
    entries.forEach((entry) => {
      /** @type {HTMLElement} */
      // @ts-ignore
      const element = entry.target;
      const once = element.dataset.animationOnce === 'true';

      if (entry.isIntersecting) {
        element.classList.add('animated');
        if (once) {
          // Find the right observer to unobserve from
          const offset = element.dataset.animationOffset || '10';
          const observer = observers.get(offset);
          if (observer) observer.unobserve(element);
        }
      } else {
        if (!once) {
          element.classList.remove('animated');
        }
      }
    });
  }

  animations.forEach((el) => {
    /** @type {HTMLElement} */
    // @ts-ignore
    const element = el;
    // Get the offset for this specific element
    const offset = element.dataset.animationOffset || '10';

    // If we don't have an observer for this offset yet, create one
    if (!observers.has(offset)) {
      const margin = `0px 0px -${offset}% 0px`;
      const observer = new IntersectionObserver(onAnimate, {
        root: null,
        rootMargin: margin,
        threshold: 0,
      });
      observers.set(offset, observer);
    }

    // Observe the element with the corresponding observer
    observers.get(offset).observe(element);
  });

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', () => {
    // Re-initialize if sections are added
    const newAnimations = document.querySelectorAll('[data-animate]:not(.animated)');
    newAnimations.forEach((el) => {
      /** @type {HTMLElement} */
      // @ts-ignore
      const element = el;
      const offset = element.dataset.animationOffset || '10';
      if (!observers.has(offset)) {
        const margin = `0px 0px -${offset}% 0px`;
        observers.set(offset, new IntersectionObserver(onAnimate, {
          root: null,
          rootMargin: margin,
          threshold: 0,
        }));
      }
      observers.get(offset).observe(element);
    });
  });
})();
